import { ProductFamily } from "./product";

/**
 * Device-specific GPIO voltage level labels, by product family.
 *
 * These take precedence over the options the ESI declares for 0x2214:01, and
 * are the only source of them for a family whose ESI declares none.
 *
 * A family is left out when its levels are unknown, or when the parameter should
 * stay a plain numeric input -- Circulo NG is left out for that reason, and its
 * ESI declares no options either, so nothing offers a selection for it.
 *
 * Leave such a family out rather than giving it an empty entry: an absent family
 * falls through to whatever the ESI declares, whereas an empty object is not
 * nullish and would blank the option list.
 */
export type GpioVoltageLevelOptions = Partial<Record<ProductFamily, { [key: string]: number }>>;

export const gpioVoltageLevelOptions: GpioVoltageLevelOptions = {
  'Core': {},
  Node: { 'Default voltage (3.3 V)': 1 },
  Circulo: { 'Default voltage (3.3 V)': 1, 'Alternative voltage (5 V)': 2 },
  Integro: { 'Default voltage (24 V)': 1 },
  'ACTILINK-JD Duo':  { 'Default voltage (3.3 V)': 1, 'Alternative voltage (5 V)': 2 },
  'ACTILINK-JD':  { 'Default voltage (3.3 V)': 1, 'Alternative voltage (5 V)': 2 },
  'ACTILINK-S Integro': { 'Default voltage (24 V)': 1 },
};
